import React from "react";
import { Form } from "react-bootstrap";

const Checkbox = ({ name, label, checked = false, onChange, ...rest }) => {
  return (
    <Form.Check
      {...rest}
      type="checkbox"
      id={name}
      name={name}
      label={label}
      checked={checked}
      onChange={onChange}
    />
  );
};

export default Checkbox;
